export const logs={
  TH:{
    log_date:"วันเวลาดึงข้อมูล",
    action:"ประเภทการดึงข้อมูล",
    username:"ผู้ดึงข้อมูล",
    view_body:"แสดงข้อมูลที่ส่ง",
    search:"ค้นหา",
    start_date:"วันเริ่มต้น",
    end_date:"วันสิ้นสุด",
    All:"ทั้งหมด"
  },
  EN:{
    log_date:"log date",
    action:"action",
    username:"username",
    view_body:"view body",
    search:"search",
    start_date:"start_date",
    end_date:"end_date",
    All:"All"
    
  }
}
